export { useMppAttestationTypeQuery } from './useMppAttestationTypeQuery';
